import { Icon } from "components/Component";
import { ChatDetailContext } from "contexts/chatDetailContext";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import Select from "react-select";
import { Badge, Button, Col, Modal, ModalBody, Row, Spinner } from "reactstrap";
import { servicePutChat, serviceResetTag } from "services/chats";
import {
  serviceCreateCrmResolve,
  serviceDeleteCrmProduct,
  serviceGetCrmById,
  serviceGetCrmResolveByParam,
} from "services/crmResolve";
import { serviceSendMessage } from "services/messages";
import { serviceGetContact } from "services/contact";
import { serviceGetResolveAstro } from "services/productAstro";
import { servicePutTickets } from "services/tickets";
import { serviceGetTransactions, serviceResolveTransaction } from "services/transactions";
import Swal from "sweetalert2";
import { formatCurrencyIDR, formatTransactionOptionLabel, toResolveProducts } from "utils/formatTransaction";
import { delay } from "utils/Utils";

const ChatModalResolve = (props) => {
  const { cookies, chat, setMessages, isModalResolveOpen, setIsModalResolveOpen, AfterAssign } =
    props;
  // const [inputSearch, setInputSearch] = useState("");
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [loginId] = useState(null);
  const [purchasedProducts, setPurchasedProducts] = useState([]);
  const [loadmore, setLoadmore] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [Uchat, setUchat] = useContext(ChatDetailContext);
  const deptId = chat?.channel?.departmentId;
  const selectedPc = cookies.pcData.find((itm) => itm?.deptId === Uchat?.channel?.department?.id);
  const membershipDeptList = [4, 6, 7];

  /*
  debounce afif search text
  const [resultList, setResultList] = useState([...dataProducts]);
  const [dataList, setDataList] = useState([...dataProducts]);
  useEffect(() => {
    if (inputSearch !== "") {
      const newResultList = [];
      dataList.map((data, index) => {
        if (data.product_name.toLowerCase().includes(inputSearch.toLocaleLowerCase())) {
          newResultList.push(data);
        }
      });
      setResultList(newResultList);
    } else {
      setResultList(dataList);
    }
  }, [inputSearch]);
  */

  const [lookupType, setLookupType] = useState("phone"); // "phone" | "email"
  const [lookupValue, setLookupValue] = useState("");
  const [isCheckingTx, setIsCheckingTx] = useState(false);
  const [txList, setTxList] = useState([]);
  const [txChecked, setTxChecked] = useState(false);
  const [txError, setTxError] = useState("");
  const [contactEmail, setContactEmail] = useState("");

  const handleLookupTypeChange = (type) => {
    setLookupType(type);
    setTxList([]);
    setTxChecked(false);
    setTxError("");
    if (type === "phone") {
      setLookupValue(chat?.customerPhone || Uchat?.customerPhone || "");
    } else {
      setLookupValue(contactEmail || chat?.contact?.emails?.[0]?.email || "");
    }
  };

  const isPhoneValid = (val) => /^\+?[0-9]{8,16}$/.test(val ? val.trim() : "");
  const isEmailValid = (val) => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(val ? val.trim() : "");
  const isLookupValueValid = lookupType === "phone" ? isPhoneValid(lookupValue) : isEmailValid(lookupValue);

  const handleCheckTransaction = async () => {
    if (!lookupValue || !lookupValue.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Perhatian",
        text: `Silakan masukkan ${lookupType === "phone" ? "Nomor Telepon" : "Email"} client terlebih dahulu.`,
      });
      return;
    }

    const trimmedVal = lookupValue.trim();

    if (lookupType === "phone" && !isPhoneValid(trimmedVal)) {
      Swal.fire({
        icon: "warning",
        title: "Format Nomor Telepon Tidak Valid",
        text: "Nomor telepon harus terdiri dari 8-16 digit angka (contoh: 08123456789 atau +628123456789).",
      });
      return;
    }

    if (lookupType === "email" && !isEmailValid(trimmedVal)) {
      Swal.fire({
        icon: "warning",
        title: "Format Email Tidak Valid",
        text: "Format email tidak valid. Masukkan format email yang benar (contoh: nama@domain.com).",
      });
      return;
    }

    setIsCheckingTx(true);
    setTxError("");
    setTxChecked(false);

    try {
      const payload = { startTransactionDate: chat?.createdAt || Uchat?.createdAt };
      if (lookupType === "phone") {
        payload.clientPhone = trimmedVal;
      } else {
        payload.clientEmail = trimmedVal;
      }

      const res = await serviceGetTransactions(payload);

      if (res?.status === 200 && res?.data) {
        const items = res.data.data || [];
        setTxList(items);
        setTxChecked(true);
        if (items.length === 0) {
          setTxError(
            `Tidak ada transaksi ditemukan untuk ${
              lookupType === "phone" ? "nomor telepon" : "email"
            } ini.`
          );
        }
      } else {
        setTxList([]);
        setTxChecked(true);
        const errMsg =
          res?.data?.message ||
          res?.statusText ||
          "Gagal menghubungi service transaksi (localhost:8880). Pastikan service sedang berjalan.";
        setTxError(errMsg);
      }
    } catch (err) {
      console.error("Error checking transaction:", err);
      setTxList([]);
      setTxChecked(true);
      setTxError("Terjadi kesalahan saat memanggil service transaksi.");
    } finally {
      setIsCheckingTx(false);
    }
  };

  useEffect(() => {
    setPurchasedProducts([]);
    setLoadmore(1);
    setTxList([]);
    setTxChecked(false);
    setTxError("");
    if (isModalResolveOpen) {
      refreshDataCustomer();
      const phone = chat?.customerPhone || Uchat?.customerPhone || "";
      if (lookupType === "phone") {
        setLookupValue(phone);
      }
      const contactId = chat?.contactId || Uchat?.contactId;
      if (contactId) {
        serviceGetContact(cookies.SIDikey, contactId).then((res) => {
          if (res?.status === 200 && res?.data) {
            const email = res.data?.emails?.[0]?.email || "";
            setContactEmail(email);
            if (lookupType === "email" && email) {
              setLookupValue(email);
            }
          }
        });
      }
    } else {
      setSelectedProducts([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isModalResolveOpen]);

  const handleSelectedProduct = (e) => {
    setSelectedProducts(e ? [e] : []);
  };

  const refreshDataCustomer = async () => {
    const resp = await serviceGetCrmResolveByParam(
      cookies.SIDikey,
      chat?.contactId,
      deptId,
      chat.customerPhone,
      chat.id,
      1,
    );
    // const resp = await serviceGetCrmResolveByParam(cookies.SIDikey, chat?.contactId, null, chat.id);
    if (resp.status === 200) {
      const prodRaws = resp.data.data;
      const prods = [];
      prodRaws.forEach((prodRaw) => {
        const prodEnd = JSON.parse(prodRaw.productDescription);
        if (prodEnd !== null) {
          // prodEnd.forEach((pr) => {
          // });
          if (prodEnd[0]["id"] || prodEnd[0]["id"]) {
            prods.push({
              items: prodEnd,
              crmId: prodRaw.id,
              timestamp: prodRaw.createdAt,
              status: prodRaw.status,
              ticketId: prodRaw.ticketId,
            });
          } else {
            prods.push({
              items: prodEnd[0],
              crmId: prodRaw.id,
              timestamp: prodRaw.createdAt,
              status: prodRaw.status,
              ticketId: prodRaw.ticketId,
            });
          }
        }
      });
      setLoadmore(1);
      setPurchasedProducts(prods);
    }
  };

  const removeTag = async (id) => {
    await serviceResetTag(cookies.SIDikey, [{ id: id, tagIds: [] }]);
  };

  async function serviceGetResolveWithTimeout(cookies, params, timeout = 8000) {
    return new Promise((resolve, reject) => {
      const timer = setTimeout(() => {
        reject(new Error("Request timed out"));
      }, timeout);

      serviceGetResolveAstro(cookies, params)
        .then((response) => {
          clearTimeout(timer);
          resolve(response);
        })
        .catch((err) => {
          clearTimeout(timer);
          reject(err);
        });
    });
  }

  // SUBMIT RESOLVE
  const handleSubmit = async () => {
    setIsLoading(true);
    setLoadmore(1);
    if (!Uchat.contactId) {
      Swal.fire("Contact belum di simpan", "Mohon simpan contact terlebih dahulu!", "error");
      setIsLoading(false);
      return;
    }
    // jika status masih resolved
    // rubah
    if (Uchat.status === "RESOLVED") {
      Swal.fire("Disabled Resolve", `Chat masih dalam keadaan ${Uchat.status}`, "error");
      setIsLoading(false);
      return;
    }
    // jika user bukan userId dan ia adalah sales
    if (Uchat.userId !== cookies.id && (cookies.role.name === "SALES" || cookies.role.name === "CS")) {
      Swal.fire("Disabled Resolve", `Anda bukan PIC`, "error");
      setIsLoading(false);
      return;
    }

    if (cookies.role.name !== "SALES" && cookies.role.name !== "CS") {
      Swal.fire("Disabled Resolve", `Anda Tidak Berwenang`, "error");
      setIsLoading(false);
      return;
    }
    const newChat = chat;
    const ticketId = newChat?.ticketId ?? newChat?.tickets[0].id;

    if (!ticketId) {
      Swal.fire("WARNING", "Ticket ID was not found", "warning");
      setIsLoading(false);
      return;
    }

    const formattedDate = new Date(Date.now()).toLocaleString("en-GB", {
      month: "numeric",
      year: "numeric",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false, // Ensuring 24-hour format
    });

    // Splitting the formatted date into date and time components
    const [datePart, timePart] = formattedDate.split(", ");

    let dataToAstro = {};
    let dataToResolver = null;

    if (membershipDeptList.includes(selectedPc?.pc) && loginId !== null) {
      dataToAstro = {
        pc: selectedPc?.pc ?? 0,
        login_id: parseInt(loginId),
        phone: "+" + Uchat.customerPhone,
        ticket: ticketId,
      };
    } else if (selectedProducts.length > 0) {
      dataToResolver = {
        crmTicketId: ticketId,
        orderId: selectedProducts[0].item.order_id,
        pc: selectedProducts[0].item.profit_center,
      };
    }

    if (loginId !== null || selectedProducts.length > 0) {
      let dataLoop = 0;
      const allDataTransaction = [];
      let isResolvedAstro = false;

      try {
        let respResolve;

        if (dataToResolver) {
          respResolve = await serviceResolveTransaction(dataToResolver);
          isResolvedAstro = respResolve?.status === 200 || respResolve?.status === 201;
        } else {
          respResolve = await serviceGetResolveWithTimeout(cookies.AstroKey, dataToAstro, 10000);
          isResolvedAstro = respResolve?.data.status === "success";
        }

        if (isResolvedAstro) {
          allDataTransaction.push({ respResolve: respResolve, prodId: selectedProducts[dataLoop].item.product });
        } else {
          setIsLoading(false);
          Swal.fire("Not Found", "Transaction not found in Astronacci DB.", "error");
        }
      } catch (error) {
        setIsLoading(false);
        // console.error(`Failed to resolve for product ${selectedProducts[dataLoop].item.id}:`, error);
        Swal.fire("Timeout From Astro", "Astronacci backend taking too long, pleas try again!", "error");
        return false; // Return false if any request fails or times out
      }

      const status = isResolvedAstro ? "RESOLVED" : "PENDING";

      let produtsString = "";
      let productsArray = [];
      let productsJson = [];

      if (selectedProducts.length > 0) {
        selectedProducts.forEach((element) => {
          toResolveProducts(element.item).forEach((p) => {
            produtsString += `\n (${p.id}) ${p.productName} [${formatCurrencyIDR(p.price)}]`;
            productsArray.push(p.id);
            productsJson.push(p);
          });
        });
      } else if (loginId !== null) {
        productsArray = [parseInt(loginId)];
        productsJson = [
          {
            id: parseInt(loginId),
            productName: selectedPc.name + " Membersip.",
            price: 0,
          },
        ];
      }

      const dataCrmResolve = {
        phone: chat.customerPhone,
        product: 0,
        pc: selectedPc?.pc ?? 0,
        products: productsArray,
        chatId: chat.id,
        contactId: chat.contactId,
        ticketId: chat?.tickets[0].id,
        productDescription: JSON.stringify(productsJson),
        status: status,
        sendToCustomer: isResolvedAstro ? 1 : 0,
        // sendToCustomer: selectedProducts.length - 1 === resolveLoop && findNotFoundTransation < 0 ? 1 : 0,
      };

      await serviceCreateCrmResolve(cookies.SIDkey, dataCrmResolve, status);

      if (!isResolvedAstro) {
        Swal.fire("WARNING", "Transaction Not Found in Astro", "warning");
        await delay(1000);
        newChat.status = "PENDING";
        newChat.adminStatus = "PENDING";
        newChat.csStatus = "PENDING";
        newChat.superStatus = "PENDING";
        newChat.headStatus = "PENDING";
        newChat.auditorStatus = "PENDING";
        newChat.sysAdminStatus = "PENDING";
      } else {
        Swal.fire("FOUND", "Transaction Found", "success");
        newChat.status = "RESOLVED";
        newChat.adminStatus = "RESOLVED";
        newChat.csStatus = "RESOLVED";
        newChat.superStatus = "RESOLVED";
        newChat.headStatus = "RESOLVED";
        newChat.auditorStatus = "RESOLVED";
        newChat.sysAdminStatus = "RESOLVED";
      }

      const respPutChat = await servicePutChat(cookies.SIDkey, Uchat.id, {
        status: status,
        adminStatus: status,
        csStatus: status,
        headStatus: status,
        superStatus: status,
        auditorStatus: status,
        sysAdminStatus: status,
        unreadCount: 0,
        unreadCountCs: 0,
        unreadCountAdmin: 0,
        unreadCountHead: 0,
        unreadCountSuper: 0,
        unreadCountAuditor: 0,
        unreadCountSysAdmin: 0,
      });

      if (respPutChat.status !== 202) {
        Swal.fire("Gagal ubah status chat.", "mohon coba lagi", "error");
        setIsLoading(false);
        return;
      }

      // ROLECHAT
      newChat.status = status;
      newChat.adminStatus = status;
      newChat.csStatus = status;
      newChat.headStatus = status;
      newChat.superStatus = status;
      newChat.auditorStatus = status;
      newChat.sysAdminStatus = status;
      newChat.unreadCount = 0;
      newChat.unreadCountAdmin = 0;
      newChat.unreadCountCs = 0;
      newChat.unreadCountHead = 0;
      newChat.unreadCountSuper = 0;
      newChat.unreadCountAuditor = 0;
      newChat.unreadCountSysAdmin = 0;

      // await servicePutContact(cookies.SIDkey, newChat.contactId, { metadata: selectedProducts });
      await servicePutTickets(Uchat?.tickets[0].id, cookies.SIDikey, { status: status });

      const dataMessage = {
        type: "PURCHASE",
        status: "READ",
        text: `Chat Session ${newChat.status} pada ${datePart} ${timePart}
        \n ${produtsString}`,
        chatId: newChat.id,
        wa_id: newChat.customerPhone,
        ticketId: Uchat?.tickets[0].id ?? newChat?.tickets[0].id,
      };

      dataMessage["fromMe"] = true;

      const resp = await serviceSendMessage(cookies.SIDkey, dataMessage);
      setUchat({ ...newChat });

      // AfterAssign();
      setMessages((messages) => [...messages, resp.data]);

      if (respPutChat.data.status === "RESOLVED") {
        Swal.fire("Submited", "resolve", "success");
        newChat.tags = [];
        setUchat({ ...newChat });
        removeTag(newChat.id);
      } else {
        Swal.fire("Submited", "pending", "warning");
      }

      refreshDataCustomer();
    } else {
      Swal.fire("Pilih Item", "resolve", "error");
    }
    setIsLoading(false);
  };

  // resolve icon based on status and role
  const SolveIcon = () => {
    if (Uchat.status === "RESOLVED") return <i className="bi bi-check-circle modal-resolve-icon"></i>;
    if (Uchat.status === "PENDING")
      return <i className="bi bi-exclamation-circle modal-resolve-icon pending-status"></i>;
    return <i className="bi bi-box-arrow-in-up modal-resolve-icon blue"></i>;
  };

  // add more item to history list
  async function handleLoadMore() {
    const resp = await serviceGetCrmResolveByParam(
      cookies.SIDikey,
      chat?.contactId,
      deptId,
      chat.customerPhone,
      chat.id,
      loadmore + 1,
    );
    // const resp = await serviceGetCrmResolveByParam(cookies.SIDikey, chat?.contactId, null, chat.id);
    if (resp.status === 200) {
      const prodRaws = resp.data.data;
      const prods = purchasedProducts;
      prodRaws.forEach((prodRaw) => {
        const prodEnd = JSON.parse(prodRaw.productDescription);
        if (prodEnd !== null) {
          prodEnd.forEach((pr) => {
            prods.push({
              items: pr,
              crmId: prodRaw.id,
              timestamp: prodRaw.createdAt,
              status: prodRaw.status,
              ticketId: prodRaw.ticketId,
            });
          });
        }
      });

      setPurchasedProducts(prods);
      if (loadmore < resp.data.meta.pageCount) {
        setLoadmore(loadmore + 1);
      } else {
        setLoadmore(-1);
      }
    }
  }

  const handleDeletePendingProducts = async (product) => {
    Swal.fire({
      title: "Apakah anda yakin untuk menghapus Product ini?",
      text: "",
      icon: "warning",
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#1ee0ac",
      confirmButtonText: "Ya, hapus!",
      cancelButtonText: "Tidak",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const respCrmHistory = await serviceGetCrmById(cookies.SIDikey, product.crmId, product.ticketId);

          // delete crm
          await serviceDeleteCrmProduct(cookies.SIDikey, product.crmId);

          if (respCrmHistory.data) {
            // check products
            let validData = respCrmHistory.data.data.filter((data) => !data.products.includes(product.id));

            // if product still left, check all
            if (validData.length > 0) {
              setUchat({
                ...Uchat,
                status: "OPENED",
                adminStatus: "OPENED",
                headStatus: "OPENED",
                superStatus: "OPENED",
                csStatus: "OPENED",
                auditorStatus: "OPENED",
                sysAdminStatus: "OPENED",
              });
              // if all resolve : resolve
              const selectedPc = cookies.pcData.find((itm) => itm?.deptId === Uchat?.channel?.department?.id);

              for (const prod of validData) {
                const productId = prod.products[0];
                await serviceGetResolveAstro(cookies.AstroKey, {
                  pc: selectedPc?.pc ?? 0,
                  product: [productId],
                  phone: "+" + Uchat.customerPhone,
                  ticket: Uchat?.tickets[0].id,
                });
              }

              // change chat status to open
              // change ticket status to open
              await servicePutChat(cookies.SIDikey, Uchat.id, {
                status: "OPENED",
                adminStatus: "UNOPENED",
                csStatus: "UNOPENED",
                headStatus: "UNOPENED",
                superStatus: "UNOPENED",
                auditorStatus: "UNOPENED",
                sysAdminStatus: "UNOPENED",
                unreadCount: 0,
              });
              if (Uchat.tickets && Uchat.tickets.length > 0) {
                await servicePutTickets(Uchat.tickets[0].id, cookies.SIDikey, { status: "OPENED" });
              }

              const dataMessage = {
                type: "PURCHASE",
                status: "READ",
                text: `Chat Session OPENED, delete transaction : ${product.crmId}`,
                chatId: Uchat.id,
                wa_id: Uchat.customerPhone,
                ticketId: Uchat?.tickets[0].id,
              };

              dataMessage["fromMe"] = true;
              await serviceSendMessage(cookies.SIDkey, dataMessage);

              AfterAssign();
              setIsModalResolveOpen(false);

              return;
            } else {
              // jika tidak ada barang lainnya

              // change chat status to open
              // change ticket status to open
              await servicePutChat(cookies.SIDikey, Uchat.id, {
                status: "OPENED",
                adminStatus: "UNOPENED",
                csStatus: "UNOPENED",
                headStatus: "UNOPENED",
                superStatus: "UNOPENED",
                auditorStatus: "UNOPENED",
                sysAdminStatus: "UNOPENED",
                unreadCount: 0,
              });

              if (Uchat.tickets && Uchat.tickets.length > 0) {
                await servicePutTickets(Uchat.tickets[0].id, cookies.SIDikey, { status: "OPENED" });
              }

              setIsModalResolveOpen(false);
            }
          }
        } catch (error) {
          // //console.log(error);
        }
      }
    });
  };

  const handleCheckPendingCrm = async (product) => {
    setIsLoading(true);

    let ids = [];

    if (Array.isArray(product.items)) {
      ids = product.items.map((item) => item.id);
    } else {
      ids = [product.items.id];
      const productLocals = [product.items];
      product.items = productLocals;
    }

    const selectedPc = cookies.pcData.find((itm) => itm?.deptId === Uchat?.channel?.department?.id);

    try {
      const respResolve = await serviceGetResolveAstro(cookies.AstroKey, {
        pc: selectedPc?.pc ?? 0,
        product: ids,
        phone: "+" + Uchat.customerPhone,
        ticket: Uchat?.tickets[0].id,
      });

      if (respResolve?.data?.status !== "success") {
        Swal.fire("Transaksi tidak ditemukan", "Pastikan customer melakukan pembayaran.", "error");
        setIsLoading(false);
        return;
      }
    } catch (error) {
      Swal.fire("Transaksi tidak berhasil!", "Pastikan koneksi dan backend Astro berjalan.", "error");
      setIsLoading(false);
      return;
    }

    const formattedDate = new Date(Date.now()).toLocaleString("en-GB", {
      month: "numeric",
      year: "numeric",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false, // Ensuring 24-hour format
    });

    // Splitting the formatted date into date and time components
    const [datePart, timePart] = formattedDate.split(", ");

    const respCrmHistory = await serviceGetCrmResolveByParam(
      cookies.SIDikey,
      Uchat?.contactId,
      deptId,
      Uchat.customerPhone,
      chat.id,
      1,
      "PENDING",
    );

    const dataCrmResolve = {
      phone: Uchat.customerPhone,
      product: product.id,
      pc: selectedPc?.pc ?? 0,
      products: ids,
      chatId: Uchat.id,
      contactId: Uchat.contactId,
      ticketId: Uchat?.tickets[0].id,
      productDescription: JSON.stringify(product.items),
      status: "RESOLVED",
      sendToCustomer: respCrmHistory.data.data.length > 1 ? 0 : 1, // send rating to customer
    };

    const createCrmHistory = await serviceCreateCrmResolve(cookies.SIDkey, dataCrmResolve, "RESOLVED");

    if (createCrmHistory.statusText !== "Created") {
      Swal.fire("Gagal Resolve", "mohon coba lagi", "error");
      setIsLoading(false);
      return;
    }

    if (respCrmHistory.data.data.length > 1) {
      //CHAT ROLE
      await servicePutChat(cookies.SIDkey, Uchat.id, {
        status: "PENDING",
        adminStatus: "PENDING",
        csStatus: "PENDING",
        headStatus: "PENDING",
        superStatus: "PENDING",
        auditorStatus: "PENDING",
        sysAdminStatus: "PENDING",
        unreadCount: 0,
        unreadCountAdmin: 0,
        unreadCountCs: 0,
        unreadCountAuditor: 0,
        unreadCountSysAdmin: 0,
        unreadCountSuper: 0,
        unreadCountHead: 0,
      });
      chat.status = "PENDING";
      chat.adminStatus = "PENDING";
      chat.csStatus = "PENDING";
      chat.headStatus = "PENDING";
      chat.superStatus = "PENDING";
      chat.auditorStatus = "PENDING";
      chat.sysAdminStatus = "PENDING";
      setUchat({ ...chat });
    } else {
      // Remove tag
      removeTag(Uchat.id);

      // add resolve message
      const productString = `\n (${product.id}) ${product.productName} [Rp.${product.price}]`;

      const dataMessage = {
        type: "PURCHASE",
        status: "READ",
        text: `Chat Session RESOLVED pada ${datePart} ${timePart} \n ${productString}`,
        chatId: Uchat.id,
        wa_id: Uchat.customerPhone,
        ticketId: Uchat?.tickets[0].id,
      };

      dataMessage["fromMe"] = true;
      await serviceSendMessage(cookies.SIDkey, dataMessage);
    }
    Swal.fire("Submited", "resolve", "success");

    refreshDataCustomer();
    setIsLoading(false);
  };

  return (
    <Modal
      isOpen={isModalResolveOpen}
      backdrop="static"
      toggle={() => setIsModalResolveOpen(false)}
      className="modal-dialog-centered"
      size="lg"
    >
      <ModalBody>
        {isLoading ? (
          <Spinner></Spinner>
        ) : (
          <React.Fragment>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                setIsModalResolveOpen(false);
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="text-center">
              <span className="modal-resolve-title">Status: </span>
              <span className={`modal-resolve-title color-${Uchat.status}`}>{Uchat.status}</span>
              <div>
                <SolveIcon />
              </div>
            </div>

            {/* Panel Cek Transaksi Client (resolution-svc) - Tampilan Simpel - disembunyikan jika chat sudah PENDING atau RESOLVED */}
            {Uchat.status !== "RESOLVED" && Uchat.status !== "PENDING" && (
              <div className="card card-bordered p-3 mb-3 bg-light">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <span className="font-weight-bold text-dark" style={{ fontSize: "13px" }}>
                    <Icon name="search" className="mr-1 text-primary" /> Check Transactions
                  </span>
                  <div className="btn-group btn-group-sm" role="group">
                    <button
                      type="button"
                      className={`btn btn-xs ${lookupType === "phone" ? "btn-primary" : "btn-outline-light text-dark"}`}
                      onClick={() => handleLookupTypeChange("phone")}
                    >
                      No. Telepon
                    </button>
                    <button
                      type="button"
                      className={`btn btn-xs ${lookupType === "email" ? "btn-primary" : "btn-outline-light text-dark"}`}
                      onClick={() => handleLookupTypeChange("email")}
                    >
                      Email
                    </button>
                  </div>
                </div>

                <div className="input-group">
                  <input
                    type={lookupType === "email" ? "email" : "tel"}
                    inputMode={lookupType === "email" ? "email" : "numeric"}
                    className={`form-control ${lookupValue && !isLookupValueValid ? "border-danger" : ""}`}
                    placeholder={
                      lookupType === "phone"
                        ? "Masukkan nomor telepon client..."
                        : "Masukkan email client..."
                    }
                    value={lookupValue}
                    onChange={(e) => {
                      let val = e.target.value;
                      if (lookupType === "phone") {
                        val = val.replace(/[^0-9+]/g, "").replace(/(?!^)\+/g, "");
                      }
                      setLookupValue(val);
                      if (txChecked) {
                        setTxChecked(false);
                        setTxList([]);
                        setTxError("");
                      }
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        handleCheckTransaction();
                      }
                    }}
                  />
                  <div className="input-group-append">
                    <Button
                      color="primary"
                      disabled={isCheckingTx || !lookupValue?.trim() || !isLookupValueValid}
                      onClick={handleCheckTransaction}
                    >
                      {isCheckingTx ? (
                        <>
                          <Spinner size="sm" className="mr-1" /> Mengecek...
                        </>
                      ) : (
                        <>
                          <Icon name="search" className="mr-1" /> Check Transactions
                        </>
                      )}
                    </Button>
                  </div>
                </div>

                {/* Peringatan format input tidak valid */}
                {lookupValue && !isLookupValueValid && (
                  <div className="text-danger mt-1" style={{ fontSize: "12px" }}>
                    <Icon name="alert-circle" className="mr-1" />
                    {lookupType === "phone"
                      ? "Format nomor telepon tidak valid (masukkan 8-16 digit angka)."
                      : "Format email tidak valid (contoh: user@domain.com)."}
                  </div>
                )}

                {/* Notifikasi jika tidak ada transaksi */}
                {txChecked && txList.length === 0 && (
                  <div className="alert alert-warning py-2 mb-0 mt-2" style={{ fontSize: "13px" }}>
                    <Icon name="alert-circle" className="mr-1" />
                    {txError || "Tidak ditemukan transaksi dengan status SUCCESS."}
                  </div>
                )}
              </div>
            )}

            {/* Bagian Select Produk & Submit Resolve - HANYA MUNCUL KETIKA txChecked === true DAN txList.length > 0 */}
            {txChecked &&
              txList.length > 0 &&
              props.roleFunctions.includes("chat") &&
              Uchat.status !== "PENDING" &&
              Uchat.status !== "RESOLVED" && (
                <div className="card card-bordered p-3 mb-3 bg-white shadow-sm border-primary">
                  <h6 className="font-weight-bold mb-2 text-primary" style={{ fontSize: "13px" }}>
                    <Icon name="check-circle" className="mr-1 text-success" /> Pilih Produk yang Diselesaikan
                  </h6>
                  <div className="form-control-wrap">
                    <Select
                      onChange={(e) => handleSelectedProduct(e)}
                      placeholder="Pilih produk yang diselesaikan..."
                      options={txList.map((tx) => {
                        const txId = tx.order_id || tx.transaction_id || tx.id;
                        const optionLabel = formatTransactionOptionLabel(tx);
                        return {
                          value: txId,
                          label: optionLabel,
                          item: {
                            id: txId,
                            product_name: tx.product || optionLabel,
                            product_price: Number(tx.amount) || 0,
                            ...tx,
                          },
                          timestamp: Date.now(),
                        };
                      })}
                    />

                    <Button
                      color="primary"
                      className="mt-3 mx-auto"
                      block
                      style={{ justifyContent: "center" }}
                      onClick={(e) => handleSubmit()}
                    >
                      Submit Resolve
                    </Button>
                  </div>
                </div>
              )}
            {purchasedProducts.length > 0 ? (
              <div className="d-flex flex-column justify-content-start align-item-center mb-3 overflow-y-auto">
                <h6>Recent Purchase History</h6>
                <Row className="d-flex border">
                  <Col xs="1">Id</Col>
                  <Col xs="4">Nama</Col>
                  <Col xs="3">Timestamp</Col>
                  <Col xs="1">Status</Col>
                  <Col xs="2"></Col>
                </Row>
                {purchasedProducts.map((product, index) => {
                  let tableIds = "";
                  let tableProducts = "";

                  if (product.items.length > 1) {
                    tableIds = product.items.map((pi) => {
                      return (
                        <>
                          {" "}
                          {pi.id} <br className="150%space" />{" "}
                        </>
                      );
                    });
                    tableProducts = product.items.map((pi) => {
                      return (
                        <>
                          {" "}
                          {pi.productName} <br className="padding-0" />{" "}
                        </>
                      );
                    });
                  } else if (product.items && product.items.length > 0) {
                    tableIds = (
                      <p>
                        {" "}
                        {product?.items[0]?.id ?? ""} <br className="150%space" />{" "}
                      </p>
                    );
                    tableProducts = (
                      <p>
                        {" "}
                        {product?.items[0]?.productName ?? ""} <br className="padding-0" />{" "}
                      </p>
                    );
                  } else {
                    try {
                      tableIds = (
                        <>
                          {" "}
                          {product.items.id} <br className="150%space" />{" "}
                        </>
                      );
                      tableProducts = (
                        <>
                          {" "}
                          {product.items.productName ?? "-"} <br className="padding-0" />{" "}
                        </>
                      );
                    } catch (error) {
                      tableIds = <>-OLD INPUT-</>;
                      tableProducts = <>-OLD INPUT-</>;
                    }
                  }
                  return (
                    <Row key={index} className="history-crm-row border-bottom">
                      <Col xs="1">{tableIds}</Col>
                      <Col xs="4">{tableProducts}</Col>
                      <Col xs="3">{moment(product.timestamp).format("MMM DD, YYYY, HH:mm")}</Col>
                      <Col xs="1">
                        <Badge color={product.status === "RESOLVED" ? "success" : "warning"}>{product.status}</Badge>
                      </Col>
                      {props.roleFunctions.includes("chat") ? (
                        <Col xs="2" className="history-crm-button">
                          {product.status === "PENDING" ? (
                            <>
                              <Icon
                                name="reload-alt"
                                className="crm-recheck text-white bg-primary"
                                onClick={() => handleCheckPendingCrm(product)}
                              />
                              <Icon
                                name="trash-alt"
                                className="crm-recheck ml-1 text-white bg-danger"
                                color="primary"
                                onClick={() => handleDeletePendingProducts(product)}
                              />
                            </>
                          ) : (
                            ""
                          )}
                        </Col>
                      ) : (
                        ""
                      )}
                    </Row>
                  );
                })}
                {loadmore > 0 ? (
                  <Button
                    color="secondary"
                    className="mt-2 mb-2 mx-auto w-50"
                    block
                    style={{ justifyContent: "center" }}
                    onClick={(e) => handleLoadMore()}
                  >
                    Load More
                  </Button>
                ) : (
                  ""
                )}
              </div>
            ) : (
              <></>
            )}
          </React.Fragment>
        )}
      </ModalBody>
    </Modal>
  );
};

export default ChatModalResolve;
